import React from 'react'
import ErrorPage from '../../Components/errorPage/ErrorPage';
import { Home } from 'lucide-react';

const NotFound = () => {
    return (
        <>
        <ErrorPage errorCode={404}  content={"Oops! Looks like you're lost."} href={"/"} hrefTag={"Home"}/>

    </>
  )
}

export default NotFound;